import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PagesRoutingModule } from "./base-routing.module";
import { BaseComponent } from "./base.component";
import { MaterialModule } from "../mat-com/material.module";
import { NavigationModule } from "../navigation/navigation.module";
import { CarouselModule } from "ngx-owl-carousel-o";
import { BaseService } from "./base.service";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { VjsModule } from "../vjs/vjs.module";
import { VideoDetailComponent } from "./video-detail/video-detail.component";
import { SearchPageComponent } from "./search-page/search-page.component";
import { ImgFallbackModule } from "ngx-img-fallback";
import { ResulableSimmerModule } from "../resulable-simmer/resulable-simmer.module";
import { HomeComponent } from "./home/home.component";
import { ListComponent } from "./list/list.component";
import { VideoSeriesComponent } from "./video-series/video-series.component";
import { ContentSubscriptionComponent } from "./content-subscription/content-subscription.component";
import { VideoProviderComponent } from "./video-provider/video-provider.component";
import { NgxYoutubePlayerModule } from "ngx-youtube-player";
import { NgxDailymotionModule } from "ngx-dailymotion";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { PipeModule } from "../pipemodule/pipe.module";
import { FavoriteListComponent } from "./favorite-list/favorite-list.component";
import { AddCommentComponent } from "./add-comment/add-comment.component";
import { RatingModule } from "ng-starrating";
import { GridComponent } from "./grid/grid.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MomentModule } from "angular2-moment";
import { ModelPlayerComponent } from "./model-player/model-player.component";
import { GenereComponent } from "./genere/genere.component";
import { GenereListComponent } from "./genere-list/genere-list.component";
import { LanguageComponent } from "./language/language.component";
import { LanguageListComponent } from "./language-list/language-list.component";
import { MatRadioModule } from "@angular/material/radio";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxAudioPlayerModule } from "ngx-audio-player";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
import { NgxSocialShareModule } from "ngx-social-share";
import { VideoInfoComponent } from "./video-info/video-info.component";
import { LanguageGridComponent } from "./language-grid/language-grid.component";
import { ShareButtonsModule } from "ngx-sharebuttons/buttons";
import { ShareIconsModule } from "ngx-sharebuttons/icons";
import { StripeModule } from "stripe-angular";
import { PaymentComponent } from "./payment/payment.component";
import { ReportAbuseComponent } from "./report-abuse/report-abuse.component";
import { RecommendedListComponent } from "./recommended-list/recommended-list.component";
import { CastCrewListComponent } from "./cast-crew-list/cast-crew-list.component";
import { AudioDetailComponent } from "./audio-detail/audio-detail.component";
import { DocumentDetailComponent } from "./document-detail/document-detail.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BannerSliderComponent } from "./banner-slider/banner-slider.component";
import { GridListComponent } from "./grid-list/grid-list.component";
import { GridSliderListComponent } from "./grid-slider-list/grid-slider-list.component";
import { GenreSliderComponent } from "./genre-slider/genre-slider.component";
import { CategoryComponent } from "./category/category.component";
import { MoviesComponent } from "./movies/movies.component";
import { TvShowsComponent } from "./tv-shows/tv-shows.component";
import { PopularContentComponent } from "./content/popular-content/popular-content.component";
import { ContinueWatchingComponent } from "./content/continue-watching/continue-watching.component";
import { TopRatedContentComponent } from "./content/top-rated-content/top-rated-content.component";
import { PartnerContentComponent } from "./content/partner-content/partner-content.component";
import { PartnerContentDetailComponent } from "./partner-content-detail/partner-content-detail.component";
import { PartnerListComponent } from "./partner-list/partner-list.component";
import { MusicComponent } from "./music/music.component";
import { LiveComponent } from "./live/live.component";
import { MusicPlayerComponent } from "./music-player/music-player.component";
import { EpgProviderComponent } from "./epg-provider/epg-provider.component";
import { MusicListComponent } from "./music-list/music-list.component";
import { SocialChatComponent } from "./social-chat/social-chat.component";
import { LiveStreamingComponent } from "./live-streaming/live-streaming.component";
import { audioPlayerComponent } from "../vjs-audio/audio-player/audio-player.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { AddToPlaylistComponent } from "./add-to-playlist/add-to-playlist.component";
import { ShareMusicContentComponent } from "./share-music-content/share-music-content.component";
import { ShareDetailContentComponent } from "./share-detail-content/share-detail-content.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ActivationComponent } from "./activation/activation.component";
import { NgOtpInputModule } from "ng-otp-input";
import { PoadcastComponent } from "./poadcast/poadcast.component";
import { SongDetailComponent } from "./song-detail/song-detail.component";
import { CountdownModule } from "ngx-countdown";
// import { AngularFireAnalyticsModule } from "@angular/fire/analytics";
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFireModule } from "@angular/fire";
import { environment } from "src/environments/environment";

@NgModule({
  declarations: [
    BaseComponent,
    VideoDetailComponent,
    SearchPageComponent,
    HomeComponent,
    ListComponent,
    VideoSeriesComponent,
    ContentSubscriptionComponent,
    VideoProviderComponent,
    FavoriteListComponent,
    AddCommentComponent,
    GridComponent,
    ModelPlayerComponent,
    GenereComponent,
    GenereListComponent,
    LanguageComponent,
    LanguageListComponent,
    VideoInfoComponent,
    LanguageGridComponent,
    PaymentComponent,
    ReportAbuseComponent,
    RecommendedListComponent,
    CastCrewListComponent,
    AudioDetailComponent,
    DocumentDetailComponent,
    BannerSliderComponent,
    GridListComponent,
    GridSliderListComponent,
    GenreSliderComponent,
    CategoryComponent,
    MoviesComponent,
    TvShowsComponent,
    PopularContentComponent,
    ContinueWatchingComponent,
    TopRatedContentComponent,
    PartnerContentComponent,
    PartnerContentDetailComponent,
    PartnerListComponent,
    MusicComponent,
    LiveComponent,
    MusicPlayerComponent,
    EpgProviderComponent,
    MusicListComponent,
    SocialChatComponent,
    LiveStreamingComponent,
    audioPlayerComponent,
    AddToPlaylistComponent,
    ShareMusicContentComponent,
    ShareDetailContentComponent,
    ActivationComponent,
    PoadcastComponent,
    SongDetailComponent,
  ],
  imports: [
    NgOtpInputModule,
    NgxSpinnerModule,
    MatButtonModule,
    CommonModule,
    HttpClientModule,
    PagesRoutingModule,
    MaterialModule,
    NavigationModule,
    CarouselModule,
    AutocompleteLibModule,
    VjsModule,
    ImgFallbackModule,
    ResulableSimmerModule,
    NgxYoutubePlayerModule.forRoot(),
    InfiniteScrollModule,
    FormsModule,
    NgxDailymotionModule,
    PipeModule,
    MatDialogModule,
    RatingModule,
    MomentModule,
    MatRadioModule,
    PdfViewerModule,
    BsDropdownModule,
    NgxAudioPlayerModule,
    BsDropdownModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxSocialShareModule,
    ShareButtonsModule,
    ShareIconsModule,
    StripeModule,
    MatProgressSpinnerModule,
    CountdownModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule
  ],
  providers: [BaseService, GridSliderListComponent, ContinueWatchingComponent],
  exports: [GridComponent],
})
export class BaseModule {}
